export class SoundsAudio {
    constructor() {
        this.loop = false;
        this.source = "";
    }
    load(data) {
        if (data === undefined) {
            return;
        }
        if (typeof data === "object") {
            if (data.loop !== undefined) {
                this.loop = data.loop;
            }
            if (data.source !== undefined) {
                this.source = data.source;
            }
        }
        else {
            this.source = data;
        }
    }
}
